const getters = {
  isLogin: state => state.user.isLogin,
  userInfo: state => state.user.userInfo,
  cardInfo: state => state.user.cardInfo,
  userName: state => state.user.userName,
  sex: state => state.user.sex,
  sexId: state => state.user.sexId,
  domicilePlace: state => state.user.domicilePlace,
  id: state => state.user.id,
  idCard: state => state.user.idCard,
  mobileNumber: state => state.user.mobileNumber,
  residence: state => state.user.residence,
  isReload:state=>state.user.isReload,
  showPop:state=>state.user.showPop
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js